import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import DailyProfit from "./pages/DailyProfit";
import Chimes from "./pages/Chimes";
import CashApps from "./pages/CashApps";
import PayPals from "./pages/PayPals";
import Venmos from "./pages/Venmos";
import Links from "./pages/Links";
import Withdrawals from "./pages/Withdrawals";
import USDTSent from "./pages/USDTSent";
import CashCoinPayments from "./pages/CashCoinPayments";
import PartyBook from "./pages/PartyBook";
import PartyBookDetails from "./pages/PartyBookDetails";
import TeamCredit from "./pages/TeamCredit";
import TeamCreditDetails from "./pages/TeamCreditDetails";
import TronUSDT from "./pages/TronUSDT";
import BscUSDT from "./pages/BscUSDT";
import Expenses from "./pages/Expenses";
import Salaries from "./pages/Salaries";
import TeamAnalysis from "./pages/TeamAnalysis";
import NetProfits from "./pages/NetProfits";
import NetProfitAnalytics from "./pages/NetProfitAnalytics";
import Rates from "./pages/Rates";
import Admins from "./pages/Admins";

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors closeButton />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <ProtectedRoute permission="dashboard" cfBlock>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/daily-profit"
              element={
                <ProtectedRoute permission="dashboard">
                  <DailyProfit />
                </ProtectedRoute>
              }
            />
            <Route
              path="/chimes"
              element={
                <ProtectedRoute permission="chimes">
                  <Chimes />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cashapps"
              element={
                <ProtectedRoute permission="cashapps">
                  <CashApps />
                </ProtectedRoute>
              }
            />
            <Route
              path="/paypals"
              element={
                <ProtectedRoute permission="paypals">
                  <PayPals />
                </ProtectedRoute>
              }
            />
            <Route
              path="/venmos"
              element={
                <ProtectedRoute permission="venmos">
                  <Venmos />
                </ProtectedRoute>
              }
            />
            <Route
              path="/links"
              element={
                <ProtectedRoute permission="links">
                  <Links />
                </ProtectedRoute>
              }
            />
            <Route
              path="/withdrawals"
              element={
                <ProtectedRoute permission="withdrawals">
                  <Withdrawals />
                </ProtectedRoute>
              }
            />
            <Route
              path="/usdt-sent"
              element={
                <ProtectedRoute permission="usdt_sent">
                  <USDTSent />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cash-coin-payments"
              element={
                <ProtectedRoute permission="cash_coin_payments">
                  <CashCoinPayments />
                </ProtectedRoute>
              }
            />
            <Route
              path="/party-book"
              element={
                <ProtectedRoute permission="usdt_sent">
                  <PartyBook />
                </ProtectedRoute>
              }
            />
            <Route
              path="/party-book/:partyId"
              element={
                <ProtectedRoute permission="usdt_sent">
                  <PartyBookDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/team-credit"
              element={
                <ProtectedRoute permission="team_credit">
                  <TeamCredit />
                </ProtectedRoute>
              }
            />
            <Route
              path="/team-credit/:teamId"
              element={
                <ProtectedRoute permission="team_credit">
                  <TeamCreditDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/tron-usdt"
              element={
                <ProtectedRoute permission="usdt_sent">
                  <TronUSDT />
                </ProtectedRoute>
              }
            />
            <Route
              path="/bsc-usdt"
              element={
                <ProtectedRoute permission="usdt_sent">
                  <BscUSDT />
                </ProtectedRoute>
              }
            />
            <Route
              path="/expenses"
              element={
                <ProtectedRoute permission="expenses">
                  <Expenses />
                </ProtectedRoute>
              }
            />
            <Route
              path="/salaries"
              element={
                <ProtectedRoute permission="salaries">
                  <Salaries />
                </ProtectedRoute>
              }
            />
            <Route
              path="/team-analysis"
              element={
                <ProtectedRoute permission="team_analysis">
                  <TeamAnalysis />
                </ProtectedRoute>
              }
            />
            <Route
              path="/net-profits"
              element={
                <ProtectedRoute permission="net_profits">
                  <NetProfits />
                </ProtectedRoute>
              }
            />
            <Route
              path="/net-profit-analytics"
              element={
                <ProtectedRoute permission="net_profits">
                  <NetProfitAnalytics />
                </ProtectedRoute>
              }
            />
            <Route
              path="/rates"
              element={
                <ProtectedRoute permission="rates">
                  <Rates />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admins"
              element={
                <ProtectedRoute permission="admins">
                  <Admins />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
